if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt, addFromDropdown = false) {

        evt?.preventDefault();

        if (this.submitButton.dataset.addType == 'dropdown' && !addFromDropdown) {
          // In this case we need to open the size selector when add to cart button is clicked. This happens in the quick add of product cards
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        if (!this.submitButton.classList.contains('card-detailed__button')) {
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // config.headers['Content-Type'] = 'application/json';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        /* 
          Move add to cart items to items array so they appear in response
          This is needed to show all added items in the notifications
        */
        const items = []

        const mattressRemovalVariantId = window.settings.mattressRemovalVariantId;

        // Deep copy formData.entries() using JSON.parse(JSON.stringify())
        // Avoid modifycations to the original formData object alter the loop
        const formDataEntries = JSON.parse(JSON.stringify([...formData.entries()]));
        for (const element of formDataEntries) {

          const match = element[0].match(/items\[(\d+)\]\[id\]/);
          if (match) {

            // Delete the original formData entry for the item, as we will add it to the items array
            formData.delete(element[0]);

            // If trying to add the mattress removal product, check if already in cart. If so, skip
            if (mattressRemovalVariantId && element[1] === `${mattressRemovalVariantId}`) {

              // Get shopify cart with fetch
              const serviceProductInCart = await fetch('/cart.js')
                .then(response => response.json())
                .then(response => {
                  if (response.items.find(item => item.variant_id === mattressRemovalVariantId)) {
                    return true;
                  }
                  return false;
                });

              if (serviceProductInCart) {
                continue;
              }
            }

            items.push({
              'id': element[1],
              'quantity': formData.get(`items[${match[1]}][quantity]`) || 1
            })
          }
        }

        items.push({
          'id': formData.get('id'),
          'quantity': formData.get('quantity') || 1
        })

        this.buildFormData(formData, 'items', items);
        formData.delete('id')
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            if (!this.submitButton.classList.contains('card-detailed__button')) {
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      buildFormData(formData, key, data) {
        if (data === Object(data) || Array.isArray(data)) {
          for (const i in data) this.buildFormData(formData, `${key}[${i}]`, data[i]);
        } else data && formData.append(key, data);
      }
    }
  );
}
